import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Autocomplete, Stack, TextField } from '@mui/material'
import PropTypes from 'prop-types'
import NounGreenwashing from '~/assets/noun-greenwashing.svg?react'
import { ActionButton, Dialog } from '~/components'
import { bshSlice } from '~/store'
import EmpCoTable from './EmpCoTable'

export default function EmpCoTools(props) {
  const { shop } = props
  const { t } = useTranslation()

  const selectedEmpCo = useSelector(bshSlice.empCoSelected)
  const empCo = useSelector((state) =>
    bshSlice.empCo(state, { shopId: shop?.id })
  )
  const dispatch = useDispatch()

  const [showEmpcoDialog, setShowEmpcoDialog] = useState(false)

  const isEmpCoOptionEqual = useCallback(
    (option, value) => option?.id === value?.id,
    []
  )

  const [open, setOpen] = useState(false)

  return (
    <Stack direction="row" spacing={0.5}>
      <Autocomplete
        disablePortal
        getOptionLabel={(option) => option.target}
        getOptionKey={(option) => option.id}
        isOptionEqualToValue={isEmpCoOptionEqual}
        open={open}
        options={empCo}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t('empco.search')}
            variant="standard"
            onClick={() => setOpen(true)}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                dispatch(
                  bshSlice.selectEmpCo({
                    target: e.target.value,
                    replacement: '',
                    id: null,
                    count: 0,
                  })
                )
                e.target.blur()
              }
            }}
          />
        )}
        renderOption={(optionProps, option) => {
          const { key, ...rest } = optionProps
          return (
            <Stack
              key={key}
              component="li"
              direction="row"
              gap={0.5}
              sx={{ width: '100%', justifyContent: 'space-between !important' }}
              {...rest}
            >
              <span>{option.target}</span>
              <span>{option.count ?? 0}</span>
            </Stack>
          )
        }}
        sx={{ minWidth: 200, maxWidth: '100%' }}
        value={selectedEmpCo}
        onChange={(_, value) => {
          dispatch(bshSlice.selectEmpCo(value))
          setOpen(false)
        }}
      />
      <ActionButton
        background
        icon={<NounGreenwashing width={24} height={24} />}
        title={t('paragraph.greenwashing')}
        onClick={() => setShowEmpcoDialog((show) => !show)}
      />
      <Dialog
        actions={[
          {
            id: 'close',
            name: t('ui.close'),
            variant: 'contained',
          },
        ]}
        body={<EmpCoTable />}
        fullWidth
        maxWidth="sm"
        open={showEmpcoDialog}
        title={t('empco.title')}
        onClose={() => setShowEmpcoDialog(false)}
      />
    </Stack>
  )
}

EmpCoTools.propTypes = {
  shop: PropTypes.object,
}
